module.exports = __webpack_public_path__ + "static/bhaal-symbol-SCAG-1299f7529970d317767069425409faf1.png";